import { createStore } from 'vuex'
import { biInit } from '@/api/bi'
import ETC from '@/config/etc'
import { showNotify } from 'vant';
import { apiCheckBindPhone, apiLogin, apiGacLogin, apiLogout, apiAdUpload } from '@/api/user'
import { apiGetAddress, apiCancelRights } from '@/api/apply'
import { loadScripts } from '@/utils/common.js'
import { THIRD_TYPE } from '@/config/base'
import createPersistedState from 'vuex-persistedstate'
let checkLoginPromise = null
let channelInitPromise = {
  'gac': null,
  'baidu': null,
}
export default createStore({
  state: {
    isLogin: false,
    token: '',
    navBar: {
      title: '',
      leftArrowVisible: false,
      homeVisible: false,
    },
    navBarTitle: '',
    leftArrowVisible: '',
    channel: '',
    userInfo: {
      phone: '',
    },
    addressInfo: null,
    currentOrder: {},
    previousPage: '/',
    applyInfo: {},
    entryInfo: {
      bd_vid: '',
      pl: 0,
      entry: 1000,
      url: '',
      hasUpload: false
    },
    qaList: {},
    invoiceCardList: [], // 发票卡列表
    invoicePlateList: [], // 根据车牌号排列的卡列表
    curInvoiceCard: {}, // 当前卡
    invoiceMobile: '',
    curChosenInvoiceList: [], // 已选待开票发票列表
    calcStatusBarHeight: false,
    curBindPlate: {}, // 当前绑定的车牌及用户信息
  },
  getters: {
  },
  mutations: {
    setCurBindPlate(state, payload) {
      state.curBindPlate = payload
    },
    setEntryInfo(state, payload) {
      if (payload.pl > 0) {
        localStorage.setItem(ETC.LOCAL_STORAGE_KEY.PL, payload.pl)
        sessionStorage.setItem(ETC.SESSION_STORAGE_KEY.PL, payload.pl)
      }
      if (payload.entry && payload.entry !== 1000) {
        localStorage.setItem(ETC.LOCAL_STORAGE_KEY.ENTRY, payload.entry)
      }
      state.entryInfo = {
        ...state.entryInfo,
        ...payload
      }
    },
    setIsLogin(state, payload) {
      state.isLogin = payload
    },
    setCalcStatusBarHeight(state, payload) {
      state.calcStatusBarHeight = payload
    },
    setToken(state, payload) {
      state.token = payload
      localStorage.setItem(ETC.LOCAL_STORAGE_KEY.TOKEN, payload)
    },
    setChannel(state, payload) {
      state.channel = payload
    },
    setUserInfo(state, payload) {
      state.userInfo = {
        ...state.userInfo,
        ...payload
      }
    },
    setApplyInfo(state, payload) {
      state.applyInfo = {
        ...state.applyInfo,
        ...payload
      }
    },
    setQaList(state, payload) {
      state.qaList = {
        ...state.qaList,
        ...payload
      }
    },
    
    setNavBarTitle(state, payload) {
      state.navBar = payload
    },
    setAddressInfo(state, payload) {
      state.addressInfo = {
        ...state.addressInfo,
        ...payload
      }
    },
    clearAddressInfo(state){
      state.addressInfo = null
    },
    setCurrentOrder(state, payload) {
      state.currentOrder = payload
    },
    setPreviousPage(state, payload) {
      state.previousPage = payload
    },
    setInvoiceCardList(state, payload) {
      state.invoiceCardList = payload
    },
    setInvoicePlateList(state, payload) {
      state.invoicePlateList = payload
    },
    setCurInvoiceCard(state, payload) {
      state.curInvoiceCard = payload
    },
    setCurInvoiceMobile(state, payload) {
      state.invoiceMobile = payload
    },
    setCurChosenInvoiceList(state, payload) {
      state.curChosenInvoiceList = payload
    },
  },
  actions: {
    async handleRouteMeta({ commit, dispatch, state }, payload) {
      commit('setNavBarTitle', payload)
      await dispatch('channelInit', state.channel)
      switch (state.channel) {
        case 'gac':
          window.WindVane.call('navigator', 'config', {setting: {
            showNavBar: true,
            title: payload.title || '传祺定制ETC',
            fitsStatusBar: true,
            autoReload: true,
          }});
          break
      }
      
    },
    // 检查登录状态
    async checkLogin({ commit, state }) {
      console.log('checkLogin begin')
      if (!state.token || !state.isLogin) {
        const localToken = localStorage.getItem(ETC.LOCAL_STORAGE_KEY.TOKEN)
        console.log('localToken ==>', localToken)
        if (localToken) {
          // 查询手机号
          commit('setToken', localToken)
          try {
            checkLoginPromise = checkLoginPromise || apiCheckBindPhone({
              third_type: THIRD_TYPE
            })
            const {third_code, uid, need_login} = await checkLoginPromise
            if (need_login) {
              commit('setIsLogin', false)
            } else {
              commit('setIsLogin', true)
              commit('setUserInfo', { uid, phone: third_code })
            }
          } catch (error) {
            console.error(error)
            commit('setIsLogin', false)
          }
          checkLoginPromise = null
        }
        
      }
      return state.isLogin
    },
    // 渠道登录初始化
    async appInit({ commit, dispatch }, payload) {
      commit('setChannel', payload.channel)
      await dispatch('channelInit', payload.channel)
      localStorage.setItem(ETC.LOCAL_STORAGE_KEY.CHANNEL, payload.channel || '') 
      const {third_code, uid, need_login} = await apiCheckBindPhone({
        third_type: THIRD_TYPE,
      })
      console.log('appInit', need_login)
      if (!need_login) {
        localStorage.setItem(ETC.LOCAL_STORAGE_KEY.TOKEN, payload.token || '')
        commit('setUserInfo', { phone: third_code, uid })
        commit('setIsLogin', true)
      } else {
        commit('setIsLogin', false)
      }
      dispatch('uploadEntryInfo')
    },
    // 登录
    async login({ commit, dispatch, state }, data) {
      let api = apiLogin
      switch (state.channel) {
        case 'gac':
          api = apiGacLogin
          const gacInfo = await new Promise((resolve, reject) => {
            window.WindVane.call('account', 'getUserInfo', {}, function(res){
              console.log('getUserInfo ======success=====>>>', res)
              console.log('oneId  ======success=====>>>',res.oneId)
              if (res.oneId) {
                 localStorage.setItem('oneId',JSON.stringify(res.oneId))
              }
              resolve(res)
            }, function(res){
              // return resolve({oneId: '1912021511607611392'})
              console.error('getUserInfo ======fail=====>>>', res)
              showNotify({ type: 'danger', message: '用户信息获取失败：GAC' });
              reject(res)
            })
          })
          console.warn('gacInfo ==>', gacInfo)
          data = {
            externalUnionId: gacInfo?.oneId,
            thirdType: 50,
            verifyCode: data.verification_code,
            phone: data.send_phone,
          }
          break
        default:
          data = {third_type: THIRD_TYPE, ...data}
          break
      }
      const { uid, token } = await api(data)
      localStorage.setItem(ETC.LOCAL_STORAGE_KEY.TOKEN, token)
      localStorage.setItem(ETC.LOCAL_STORAGE_KEY.UID, uid)
      commit('setToken', token)
      commit('setIsLogin', true)
      commit('setUserInfo', { phone: data.send_phone, uid })
      dispatch('uploadEntryInfo')
      biInit()
    },
    // 登出
    async logout({ commit }){
      try {
        await apiCancelRights({rights_code: 'rt001'}) // 登出时取消权益
      } catch (error) {
        console.error('权限取消失败', error)
      }
      await apiLogout()
      localStorage.removeItem(ETC.LOCAL_STORAGE_KEY.TOKEN)
      localStorage.removeItem(ETC.LOCAL_STORAGE_KEY.UID)
      localStorage.removeItem(ETC.LOCAL_STORAGE_KEY.INVOICE_TICKETID)
      localStorage.removeItem(ETC.LOCAL_STORAGE_KEY.mobile)
      commit('setCurInvoiceMobile', '')
      commit('setCurInvoiceCard', [])
      commit('setToken', '')
      commit('clearAddressInfo')
      commit('setUserInfo', { phone: '', uid: '' })
      commit('setIsLogin', false)
    },
    // 获取地址
    async getAddressInfo({ commit }) {
      try {
        const address = await apiGetAddress({
          third_type: THIRD_TYPE
        })
        commit('setAddressInfo', address)
      } catch (error) {
        commit('setAddressInfo', {})
      }
    },
    // 广告上传
    async uploadEntryInfo({commit, dispatch, state}) {
      console.log('state.entryInfo', state.entryInfo)
      const isLogin = await dispatch('checkLogin')
      if (isLogin && state.entryInfo.bd_vid && !state.entryInfo.hasUpload) {
        commit('setEntryInfo', {
          hasUpload: true
        })
        apiAdUpload({
          bd_vid: state.entryInfo.bd_vid,
          url: state.entryInfo.url,
          pl: state.entryInfo.pl,
          entry: state.entryInfo.entry,
        })
      }
    },
    // 渠道特殊内容初始化
    async channelInit({commit, state}, payload) {
      if (payload) {
        switch (payload) {
          case 'baidu':
            if (!window.swan) {
              if (!channelInitPromise.baidu) {
                console.warn('baidu渠道script加载 -- 开始 --')
              }
              const scriptList = ['https://b.bdstatic.com/searchbox/icms/searchbox/js/swan-2.0.29.js']
              const promise = channelInitPromise.baidu || loadScripts(scriptList).then(() => {
                console.warn('baidu渠道script加载 -- 完成 --', window.swan)
              })
              channelInitPromise.baidu = promise
              await promise
              if (!window.swan) {
                // 兼容鸿蒙？
                location.reload(true)
              }
            }
            break
          case 'gac':
            // 广汽传祺app
            if (!window.WindVane) {
              if (!channelInitPromise.gac) {
                console.warn('gac渠道script加载 -- 开始 --')
              }
              const scriptList = process.env.NODE_ENV == 'qa' ? 
                ['https://g.alicdn.com/mtb/lib-windvane/3.0.0/windvane.js', 'https://presale-test.gacmotor.com/mall/jds-sdk-v1.1.1.js', 'https://presale-test.gacmotor.com/mall/windwane-hook-v1.1.0.js'] : 
                ['https://g.alicdn.com/mtb/lib-windvane/3.0.0/windvane.js', 'https://nextcdn-mall.gacmotor.com/mall/jds-sdk-v1.1.1.js', 'https://nextcdn-mall.gacmotor.com/mall/windwane-hook-v1.1.0.js']
              const promise = channelInitPromise.gac || loadScripts(scriptList).then(() => {
                console.warn('gac渠道script加载 -- 完成 --', window.WindVane)
              })
              channelInitPromise.gac = promise
              await promise
              if (!window.WindVane) {
                // 兼容鸿蒙？
                location.reload(true)
              }
            }
            break
          default:
            break
        }
      }
    }
  },
  modules: {
  },
  plugins: [
    // 状态持久化，在这里配置的状态将存储在sessionStorage里，刷新页面也不会丢失
    createPersistedState({
      key: 'etc_h5_store',
      paths: [
        'qaList',
        'isLogin',
        'token',
        'userInfo',
        'channel',
        'addressInfo',
      ],
      storage: window.sessionStorage
    })
  ]
})
